import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { IIncidentData, IMessages } from './model';
import { IncidentInfo } from './IncidentInfo';

/**
 * Tc.Module.IncidentInfoDialog
 */
export default class IncidentInfoDialog extends Module {
	private data! : IIncidentData;
	private scn! : number;
	private userName! : string;
	private incidentId! : number;
	private messages! : IMessages;
	private ajaxUrlPrefix! : string;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.scn = parseInt(this.$ctx.data('incident-scn'), 10);
		this.userName = this.$ctx.data('user-name');
		this.incidentId = parseInt(this.$ctx.data('incident-id'), 10);
		this.ajaxUrlPrefix = this.$ctx.data('ajax-url');
		this.messages = this.$ctx.data('labels');

		this.fetchData()
		.then(data => {
			this.data = data;
			(new IncidentInfo(
				this.$ctx.find('>div').get(0),
				this.data,
				this.userName,
				this.scn,
				this.messages,
			)).render();
		})
		.catch((err : JQuery.jqXHR) => this.log(err.responseText));

		callback();
	}

	private async fetchData() {
		const data = {
			outageId: this.incidentId,
			scn: this.scn,
		};
		const postData = {
			data,
			url: `${this.ajaxUrlPrefix}.details.json`,
		};

		return $.post(postData) as Promise<IIncidentData>;
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/Tc.Module.PexIncidentInfoDialog.ts